import React, { useState, useMemo } from "react";
import "./css/AboutUs.css";
import { useTable } from "react-table";

const ServiceCharter = () => {
  // === Table columns ===
  const columns = useMemo(
    () => [
      { Header: "Lot Number", accessor: "lot" },
      { Header: "Description of goods and services", accessor: "description" },
    ],
    []
  );

  // Tender extra details
  const TenderExtraDetails = ({ deadline }) => (
    <ol style={{ marginLeft: "20px", color: "#333" }} start={3}>
      <li>Bidding will be conducted in accordance with open tendering procedures of the Government of Malawi.</li>
      <li>Interested eligible bidders may obtain further information from Malawi Bureau of Standards, Ali Hassan Mwinyi Road, P.O. Box 946, Blantyre.</li>
      <li>A complete set of bidding documents in English may be obtained upon payment of a non-refundable fee of <b>MK10,000.00</b>. Payment should be made by bank deposit to: <br />
        <b>Account Name:</b> Malawi Bureau of Standards <br />
        <b>Bank:</b> National Bank of Malawi – Victoria Avenue Branch <br />
        <b>Account Number:</b> 1346148
      </li>
      <li>Bids must be delivered on or before <b>{deadline}</b>.</li>
      <li>Bids must be accompanied by a duly signed Bid Securing Declaration Form.</li>
      <li>Address for Inspection and Purchase: Procurement Office, Malawi Bureau of Standards, Ali Hassan Mwinyi Road, P.O. Box 946, Blantyre. <b>Email:</b> chikondimadona@mbsmw.org</li>
      <li>Address for Submission: Chairperson, Internal Procurement and Disposal Committee, Malawi Bureau of Standards, Ali Hassan Mwinyi Road, P.O. Box 946, Blantyre.</li>
      <li>Each bidder must comply with all instructions. Non-compliance leads to disqualification.</li>
      <li>Bids in sealed envelopes should be deposited in the Tender Box at MBS Main Reception.</li>
      <li>Bids remain valid for <b>90 days</b> after opening.</li>
      <li>MBS reserves the right to select the most substantially responsive offer.</li>
    </ol>
  );

  const tenders = [
    // {
    //   id: 1,
    //   title: "PREQUALIFICATION OF SUPPLIERS FOR VARIOUS GOODS AND SERVICES – MBS/PREQUALIFICATION/2025/26",
    //   ref: "MBS/PREQUALIFICATION/2025/26",
    //   deadline: "29th July 2025 at 14:30hrs",
    //   description: "The Malawi Bureau of Standards invites eligible suppliers to submit bids for prequalification for various goods and services.",
    //   data: [
    //     { lot: "1", description: "Supply and delivery of general stationery" },
    //     { lot: "2", description: "Supply and delivery of toners and cartridges" },
    //     { lot: "3", description: "Supply and delivery of ICT equipment, accessories, software, hardware, and printers" },
    //     { lot: "4", description: "ICT equipment maintenance" },
    //     { lot: "5", description: "Supply and delivery of various laboratory equipment" },
    //   ],
    // },
    // {
    //   id: 2,
    //   title: "SUPPLY AND DELIVERY OF MOTOR VEHICLES – MBS/VEHICLES/2025/27",
    //   ref: "MBS/VEHICLES/2025/27",
    //   deadline: "15th August 2025 at 14:30hrs",
    //   description: "MBS invites bids for the supply and delivery of motor vehicles to support institutional operations.",
    //   data: [
    //     { lot: "1", description: "Supply of double-cabin pickups" },
    //     { lot: "2", description: "Supply of 30-seater buses" },
    //   ],
    // },

    // {
    //   id: 2,
    //   title: "SUPPLY AND DELIVERY OF MOTOR VEHICLES – MBS/VEHICLES/2025/27",
    //   ref: "MBS/VEHICLES/2025/27",
    //   deadline: "15th August 2025 at 14:30hrs",
    //   description: "MBS invites bids for the supply and delivery of motor vehicles to support institutional operations.",
    //   data: [
    //     { lot: "1", description: "Supply of double-cabin pickups" },
    //     { lot: "2", description: "Supply of 30-seater buses" },
    //   ],
    // },
  ];

  const [selectedTender, setSelectedTender] = useState(null);

  const citizensTable = useTable({
    columns,
    data: selectedTender ? selectedTender.data : [],
  });

  const capitalizeWords = (str) =>
    str
      .toLowerCase()
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");

  return (
    <div className="about-us" style={{ paddingBottom: "120px", fontFamily: "Arial, sans-serif" }}>
      {/* === Overlay Header (unchanged) === */}
      <section className="about-header">
        <div className="overlay">
          <h1 className="page-title">Procurement</h1>
          <p className="subtitle">Invitation for Bid</p>
        </div>
      </section>

      {/* === Tenders Section === */}
      <section style={{ display: "flex", gap: "20px", flexWrap: "wrap", marginTop: "20px", padding: "0 20px" }}>
        {/* Left: Tender List */}
        <div
          style={{
            width: "300px",
            maxHeight: "80vh",
            overflowY: "auto",
            background: "#fff8f0",
            borderRadius: "10px",
            padding: "20px",
            boxShadow: "0 4px 15px rgba(0,0,0,0.1)",
            flexShrink: 0,
          }}
        >
          <h4 style={{ color: "#ff6600", marginBottom: "15px" }}>Available Tenders</h4>
          <ol style={{ paddingLeft: "15px" }}>
            {tenders.map((tender) => (
              <li
                key={tender.id}
                onClick={() => setSelectedTender(tender)}
                style={{
                  marginBottom: "12px",
                  cursor: "pointer",
                  fontWeight: selectedTender?.id === tender.id ? "bold" : "normal",
                  color: selectedTender?.id === tender.id ? "#ff6600" : "#333",
                  transition: "all 0.2s",
                }}
                onMouseEnter={(e) => e.currentTarget.style.color = "#ff6600"}
                onMouseLeave={(e) => e.currentTarget.style.color = selectedTender?.id === tender.id ? "#ff6600" : "#333"}
              >
                {capitalizeWords(tender.title)}
              </li>
            ))}
          </ol>
        </div>

        {/* Right: Tender Details */}
        <div
          style={{
            flex: 1,
            minWidth: "300px",
            background: "#fff",
            borderRadius: "10px",
            padding: "25px",
            boxShadow: "0 4px 20px rgba(0,0,0,0.05)",
          }}
        >
          {selectedTender ? (
            <>
              <h2 style={{ color: "#ff6600", fontSize: "22px", marginBottom: "10px" }}>
                {selectedTender.title}
              </h2>
              <p style={{ color: "#555", lineHeight: "1.6" }}>
                <strong>Reference:</strong> {selectedTender.ref} <br />
                <strong>Submission Deadline:</strong> {selectedTender.deadline} <br /><br />
                {selectedTender.description}
              </p>
<ol> <li> The MBS would like to prequalify suppliers for various goods and services. </li> <li> Eligible bidders are invited to submit sealed bids according to the category of their expertise as indicated below: – </li> </ol>
              {/* Table */}
              <table
                {...citizensTable.getTableProps()}
                style={{
                  width: "100%",
                  borderCollapse: "collapse",
                  marginTop: "20px",
                  boxShadow: "0 2px 10px rgba(0,0,0,0.05)"
                }}
              >
                <thead>
                  {citizensTable.headerGroups.map((headerGroup) => (
                    <tr {...headerGroup.getHeaderGroupProps()} style={{ backgroundColor: "#ff6600", color: "white" }}>
                      {headerGroup.headers.map((column) => (
                        <th
                          {...column.getHeaderProps()}
                          style={{ padding: "12px", textAlign: "left" }}
                        >
                          {column.render("Header")}
                        </th>
                      ))}
                    </tr>
                  ))}
                </thead>
                <tbody {...citizensTable.getTableBodyProps()}>
                  {citizensTable.rows.map((row) => {
                    citizensTable.prepareRow(row);
                    return (
                      <tr {...row.getRowProps()} style={{ borderBottom: "1px solid #ddd" }}>
                        {row.cells.map((cell) => (
                          <td {...cell.getCellProps()} style={{ padding: "10px", color: "#333" }}>
                            {cell.render("Cell")}
                          </td>
                        ))}
                      </tr>
                    );
                  })}
                </tbody>
              </table>

              {/* Extra Details */}
              <div style={{ marginTop: "25px", color: "#555" }}>
                <TenderExtraDetails deadline={selectedTender.deadline} />
              </div>
            </>
          ) : (
            <div style={{ textAlign: "center", color: "#888", marginTop: "50px" }}>
              <h2>Select a tender from the left to see details</h2>
            </div>
          )}
        </div>
      </section>
    </div>
  );
};

export default ServiceCharter;
